import { Typography } from 'antd';

const FormLabel = ({ label, ellipsis }) => {
  return (
    <Typography.Text strong ellipsis={ellipsis}>
      {label && label}
    </Typography.Text>
  );
};

const SnapshotFormLabel = ({ label, snapshotFieldValue }) => {
  return (
    <span>
      <FormLabel label={label} />:<span> &nbsp;{snapshotFieldValue}</span>
    </span>
  );
};

export { FormLabel, SnapshotFormLabel };
